import React from 'react';
import { motion } from 'framer-motion';
import { LibraryIcon, LayersIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/dJxML6sdS9Vd1dGLitULgq/ChatGPT_Image_6_sept_2026,_19_08_55.png';
const benefits = [{
  icon: LibraryIcon,
  label: '120 Ready-to-Teach Classes'
}, {
  icon: LayersIcon,
  label: '6 Professional Volumes'
}, {
  icon: DownloadIcon,
  label: 'Instant Digital Access'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-50" data-mp="xa4e131wttau">
      <div className="relative mx-auto w-full max-w-content px-5 pb-8 pt-6 sm:px-8 sm:pb-12 sm:pt-8" data-id="element-51" data-mp="sbb1bcug66bq">
        <p className="text-center font-serif text-[0.7rem] uppercase tracking-label text-forest" data-id="element-52" data-mp="ncglmjrs0xvu">
          Yoga Teacher System<sup className="text-[0.55em]" data-id="element-53" data-mp="3d1scx40hhvwa">™</sup>
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-4 max-w-3xl text-center" data-id="element-54" data-mp="3cz5u28857tyr">
          <p className="mx-auto max-w-xs text-[0.6rem] font-semibold uppercase leading-relaxed tracking-label text-gold sm:max-w-md sm:text-xs" data-id="element-55" data-mp="3o7vkflb27pxt">
            For yoga teachers tired of starting from scratch
          </p>

          <h1 className="mt-3 font-serif text-[1.85rem] font-semibold uppercase leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-56" data-mp="3e84nze2xv0v3">
            Stop planning every
            <span className="block text-forest" data-id="element-57" data-mp="358zpu8vah9jg">yoga class from scratch.</span>
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-snug text-muted sm:mt-5 sm:text-lg" data-id="element-58" data-mp="2qkdaw89kqjsr">
            A professional library of{' '}
            <span className="font-semibold text-ink" data-id="element-59" data-mp="2vj7wfhyxemgk">120 complete Ready-to-Teach classes</span> in 6
            volumes — your next class starts with a plan, not a blank page.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} src={MOCKUP} alt="Yoga Teacher System — the six volume covers of the Ready-to-Teach class library" className="mx-auto mt-4 w-full max-w-4xl sm:mt-6" width={1536} height={1024} data-id="element-60" data-mp="2lmv3wnf4aene" />

        <p className="mt-1 text-center font-serif text-sm uppercase tracking-label text-forest sm:text-lg" data-id="element-61" data-mp="1b1fg54ulm8vr">
          Open <span className="text-gold" data-id="element-62" data-mp="161jcj6ptcjgq">•</span> Choose <span className="text-gold" data-id="element-63" data-mp="162m3tfr1snx6">•</span> Teach
        </p>

        <ul className="mt-5 grid grid-cols-3 gap-2 sm:mx-auto sm:max-w-2xl sm:gap-3" data-id="element-64" data-mp="111om149y9vw7">
          {benefits.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex flex-col items-center gap-1.5 rounded-2xl border border-sandDark/70 bg-ivory/70 px-2 py-3 text-center sm:py-4" data-id="element-65" data-mp="x37bearbm3a1">
              <Icon className="h-4 w-4 shrink-0 text-sage sm:h-5 sm:w-5" aria-hidden="true" data-id="element-66" data-mp="3htg9c7teujic" />
              <span className="text-[0.6rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-[0.7rem]" data-id="element-67" data-mp="1x783xkq1jlsj">
                {label}
              </span>
            </li>)}
        </ul>

        <div className="mt-5" data-id="element-68" data-mp="26868c44e5vbn">
          <CtaButton label="Get the complete Yoga Teacher System™" microcopy="One-Time Purchase • No Subscription • Instant Access" data-id="element-69" data-mp="2b1984tzri10a" />
        </div>
      </div>
    </header>;
}